module.exports = __webpack_public_path__ + "static/2-4fabafed6c485cbdc0b904e040429f18.jpg";